import './App.css';
import Home from './components/main-page/Home';
import React from 'react';


function App() {
  return (
    <div className="App">
      <Home/>
    </div>
  );
}

export default App;
